import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { ProductSetTable } from '../components/rate-quote-request-product-set';
import {
  isPurchaseRQR,
  Offer,
  ProductSet as ProductSetComponent
} from '../modules/rate-quote/types';
import { seedInitialOffer } from '../redux/offer-details/slice';
import { offersSelector } from '../selectors/offer';
import { productSetSelector, purposeSelector } from '../selectors/rate-quote/rate-quote';
import { rateQuoteRequestSelector } from '../selectors/rate-quote-request';

export const ProductSet = () => {
  const dispatch = useDispatch();

  const properties = useSelector(
    createSelector(
      productSetSelector,
      purposeSelector,
      offersSelector,
      (data, purpose, offers) => ({
        data,
        purpose,
        offers
      })
    )
  );

  const sellerConcessions = useSelector(
    createSelector(
      rateQuoteRequestSelector,
      (allRqr) =>
        allRqr.map((rqr) => (isPurchaseRQR(rqr) ? rqr.sellerConcessions : undefined)).value
    )
  );

  const openOfferDetails = (payload: { lenderId: string; productSet: ProductSetComponent }) => {
    // Seed initial pmi value from previous offers with PMI that match the new offers LTV and
    // product term
    const pmi = (
      (Object.values(properties.offers) as Offer[])
        .filter(
          ({ attributes, monthlyPayment }) =>
            attributes.ltv === payload.productSet.ltv &&
            attributes.product.term === payload.productSet.product.term &&
            attributes.loanType === payload.productSet.loanType &&
            monthlyPayment.pmi != null
        )
        .sort((a, b) => (a.lastModifiedTime > b.lastModifiedTime ? -1 : 1))[0] || {
        monthlyPayment: {}
      }
    ).monthlyPayment.pmi;
    dispatch(seedInitialOffer({ ...payload, pmi, sellerConcessions }));
  };

  return <ProductSetTable {...{ ...properties, openOfferDetails }} />;
};
